import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, exhaustMap, tap } from 'rxjs/operators';
import { SessionService } from '../../user/session.service';
import { PlausibleService } from '../../core/plausible.service';
import * as SessionActions from './session.actions';

@Injectable()
export class SessionEffects {

  fetchSession$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SessionActions.fetchSession),
      exhaustMap(() =>
        this.sessionService.getSession().pipe(
          map(sessionData => SessionActions.fetchSessionSuccess({ sessionData })),
          catchError(error => of(SessionActions.fetchSessionFailure({ error })))
        )
      )
    );
  });

  trackLogin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SessionActions.loginOk),
      tap(() => this.plausible.track('Login'))
    ), { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private sessionService: SessionService,
    private plausible: PlausibleService
  ) {}
}
